





























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
import { active } from 'sortablejs';
import { changeLoading } from '@/util/plugins';
import SingleImageUpload from '@/component/single-image-upload.vue';
const { VUE_APP_FCAPI: FCAPI, VUE_APP_API } = process.env;
const API = {
  edit: `${FCAPI}/shang/ruan/page/config/index`,
  get: `${FCAPI}/shang/ruan/page/config/index/0`,
  banner_count: `${VUE_APP_API}/qy/weixin/mina/banner/getCount`,
};

const UPLOAD_DIR = {
  entry_img: 'entry_img',
};
const _ = {
  each: require('lodash/each'),
  keyBy: require('lodash/keyBy'),
};
interface Form {
  [key: string]: any;
  ware_title: string;
  ware_button_text: string;
  ware_style: number;
  entry_img1: string;
  sort: string;
  jump_id: string;
}
function initForm(remote?: any) {
  remote = remote || {};
  return {
    entry1_name: remote.entry1_name || '',
    entry1_description: remote.entry1_description || '',
    entry1_img: remote.entry1_img || '',
    entry2_name: remote.entry2_name || '',
    entry2_description: remote.entry2_description || '',
    entry2_img: remote.entry2_img || '',
    ware_title: remote.ware_title || '',
    ware_button_text: remote.ware_button_text || '',
    ware_style: remote.ware_style || 1,
    entry_img1: remote.entry_img1 || '',
    sort: remote.sort || '',
    jump_id: remote.jump_id || '',
  };
}
const MAX_LENGTH_6 = 6;
const MAX_LENGTH_8 = 8;
const MAX_LENGTH_10 = 10;
const MAX_LENGTH_4 = 4;
@Component({
  components: {
    SingleImageUpload,
  },
})
export default class HomePage extends Vue {
  is_dev: boolean = false; // 判断当前环境
  banner_count: number | undefined = 0;
  is_loading: boolean = false;
  is_btn_loading: boolean = false;
  form_item_layout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 19 },
  };
  validateMap: any = {
    name1: {
      status: '',
      help: '',
    },
    desc1: {
      status: '',
      help: '',
    },
    img1: {
      status: '',
      help: '',
    },
    name2: {
      status: '',
      help: '',
    },
    desc2: {
      status: '',
      help: '',
    },
    img2: {
      status: '',
      help: '',
    },
    jump_id: {
      status: '',
      help: '',
    },
    entry_img: {
      status: '',
      help: '',
    },
  };
  form: Form = initForm();
  get inputButton() {
    return 4;
  }
  get maxLength6() {
    return MAX_LENGTH_6;
  }
  get maxLength8() {
    return MAX_LENGTH_8;
  }
  get maxLength10() {
    return MAX_LENGTH_10;
  }
  get maxLength4() {
    return MAX_LENGTH_4;
  }
  get inputTitle() {
    return 10;
  }
  get uploadDir() {
    return UPLOAD_DIR;
  }
  beforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  // 点击提交按钮
  @changeLoading(['is_loading'])
  async submit() {
    const name = !!this.form.entry1_name;
    const desc = !!this.form.entry1_description;
    const img = !!this.form.entry1_img;
    const name2 = !!this.form.entry2_name;
    const desc2 = !!this.form.entry2_description;
    const img2 = !!this.form.entry2_img;
    if (name || desc || img) {
      if (!name) {
        this.validateMap.name1.status = 'error';
        this.validateMap.name1.help = '请输入名称';
        return;
      } else {
        this.validateMap.name1.status = '';
        this.validateMap.name1.help = '';
      }
      if (!desc) {
        this.validateMap.desc1.help = '请输入名称';
        this.validateMap.desc1.status = 'error';
        return;
      } else {
        this.validateMap.desc1.help = '';
        this.validateMap.desc1.status = '';
      }
      if (!img) {
        this.validateMap.img1.status = 'error';
        this.validateMap.img1.help = '请上传入口图';
        return;
      } else {
        this.validateMap.img1.help = '';
        this.validateMap.img1.status = '';
      }
    } else {
      this.validateMap.name1.status = '';
      this.validateMap.name1.error = '';
      this.validateMap.img1.status = '';
      this.validateMap.img1.error = '';
      this.validateMap.desc1.status = '';
      this.validateMap.desc1.error = '';
    }
    if (name2 || desc2 || img2) {
      if (!name2) {
        this.validateMap.name2.status = 'error';
        this.validateMap.name2.help = '请输入名称';
        return;
      } else {
        this.validateMap.name2.status = '';
        this.validateMap.name2.help = '';
      }
      if (!desc2) {
        this.validateMap.desc2.help = '请输入名称';
        this.validateMap.desc2.status = 'error';
        return;
      } else {
        this.validateMap.desc2.help = '';
        this.validateMap.desc2.status = '';
      }
      if (!img2) {
        this.validateMap.img2.status = 'error';
        this.validateMap.img2.help = '请上传入口图';
        return;
      } else {
        this.validateMap.img2.help = '';
        this.validateMap.img2.status = '';
      }
    } else {
      this.validateMap.name2.status = '';
      this.validateMap.name2.error = '';
      this.validateMap.img2.status = '';
      this.validateMap.img2.error = '';
      this.validateMap.desc2.status = '';
      this.validateMap.desc2.error = '';
    }
    if (this.form.jump_id || this.form.entry_img1) {
      if (!this.form.jump_id) {
        this.validateMap.jump_id.status = 'error';
        this.validateMap.jump_id.help = '请输入跳转活动ID';
        return;
      } else {
        this.validateMap.jump_id.status = '';
        this.validateMap.jump_id.help = '';
      }
      if (!this.form.entry_img1) {
        this.validateMap.entry_img.status = 'error';
        this.validateMap.entry_img.help = '请上传入口图';
        return;
      } else {
        this.validateMap.entry_img.status = '';
        this.validateMap.entry_img.help = '';
      }
    } else {
      this.validateMap.entry_img.status = '';
      this.validateMap.entry_img.help = '';
      this.validateMap.jump_id.status = '';
      this.validateMap.jump_id.help = '';
    }
    const send_data: any = {
      content: {
        marketing: [
          {
            name: this.form.entry1_name,
            description: this.form.entry1_description,
            image: this.form.entry1_img,
          },
        ],
      },
    };
    if (this.form.entry2_name) {
      send_data.content.marketing.push({
        name: this.form.entry2_name,
        description: this.form.entry2_description,
        image: this.form.entry2_img,
      });
    }
    if (this.form.entry_img1) {
      send_data.content.activity = {
        image: this.form.entry_img1,
        activity_id: this.form.jump_id,
      };
    }
    const res = await this.$axios.post(API.edit, send_data);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('保存成功');
  }

  // 获取配置详情
  @changeLoading(['is_loading'])
  async getConfigDetail() {
    const res = await this.$axios.get(API.get);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    const data = res.data.data || {
      content: {},
    };
    this.form = initForm();
    this.form.entry1_img = data.content.marketing ? data.content.marketing[0].image : '';
    this.form.entry1_name = data.content.marketing ? data.content.marketing[0].name : '';
    this.form.entry1_description = data.content.marketing ? data.content.marketing[0].description : '';
    this.form.entry2_img = data.content.marketing
      ? data.content.marketing[1]
        ? data.content.marketing[1].image
        : ''
      : '';
    this.form.entry2_name = data.content.marketing
      ? data.content.marketing[1]
        ? data.content.marketing[1].name
        : ''
      : '';
    this.form.entry2_description = data.content.marketing
      ? data.content.marketing[1]
        ? data.content.marketing[1].description
        : ''
      : '';
    this.form.jump_id = data.content.activity ? data.content.activity.activity_id : '';
    this.form.entry_img1 = data.content.activity ? data.content.activity.image : '';
  }

  @changeLoading(['is_loading'])
  async created() {
    this.is_dev = process.env.VUE_APP_STAGE === 'dev';
    await this.getConfigDetail();
    this.$axios.get(API.banner_count).then(({ data: { data } }) => {
      this.banner_count = data.count;
    });
  }
}
